module.exports = __webpack_public_path__ + "static/img/3-01.5f024b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/3-01.png
// module id = 228
// module chunks = 0